import { useEffect, Component } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { ContentProvider } from "@/context/ContentContext";
import Sidebar from "@/components/Sidebar";
import MobileNav from "@/components/MobileNav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Projects from "@/pages/Projects";
import Experience from "@/pages/Experience";
import Skills from "@/pages/Skills";
import Certifications from "@/pages/Certifications";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Setup from "@/pages/Setup";
import Admin from "@/pages/Admin";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        return this.state.hasError ? (
            <div className="p-10 mono text-sm">
                Something went wrong. Please refresh the page.
            </div>
        ) : (
            this.props.children
        );
    }
}

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

function PublicShell() {
    return (
        <>
            <MobileNav />
            <Sidebar />
            <div className="lg:pl-72 xl:pl-80">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/projects" element={<Projects />} />
                    <Route path="/experience" element={<Experience />} />
                    <Route path="/skills" element={<Skills />} />
                    <Route
                        path="/certifications"
                        element={<Certifications />}
                    />
                    <Route path="/contact" element={<Contact />} />
                </Routes>
                <Footer />
            </div>
        </>
    );
}

export default function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <BrowserRouter>
            <ErrorBoundary>
                <ContentProvider>
                    <ScrollToTop />
                    <div className="min-h-screen bg-paper text-ink">
                        <div className="grain" aria-hidden />
                        <Routes>
                            <Route path="/login" element={<Login />} />
                            <Route path="/setup" element={<Setup />} />
                            <Route path="/admin" element={<Admin />} />
                            <Route path="*" element={<PublicShell />} />
                        </Routes>
                        <Toaster
                            position="bottom-right"
                            toastOptions={{
                                style: {
                                    background: "#161A16",
                                    color: "#EFEEE6",
                                    border: "1px solid #2D332D",
                                    borderRadius: 0,
                                    fontFamily: "'Space Mono', monospace",
                                    fontSize: "12px",
                                },
                            }}
                        />
                    </div>
                </ContentProvider>
            </ErrorBoundary>
        </BrowserRouter>
    );
}
